const pulseSpinTheWheeltnc = {
  header: "MTN Pulse Trivia (Digital) Terms and Conditions",
  body: [
    {
      title: "INTRODUCTION",
      details: `A. MTN Pulse, catering to the vibrant youth segment of ages 15-35, is excited to
        present the Spin the Wheel Contest (“the Contest”).
        `,
    },
    {
      title: ``,
      details: `B. This initiative, specifically designed for our dynamic and energetic young
        customers, offers an engaging and rewarding experience.
        `,
    },
    {
      title: ``,
      details: `C. Accessible exclusively through the Pulse section of the myMTN App, the Contest
        promises a blend of fun, excitement, and the thrill of winning will offer a unique
        opportunity to celebrate the spirit of youth and festivity.
        `,
    },
    {
      title: `ELIGIBILITY`,
      details: `a. Participation is open to MTN Pulse customers who meet the daily threshold of GHC10.00 mashup on myMTN App.`,
    },
    {
      title: ``,
      details: `b. Employees of MTN and their immediate family members are not eligible to participate.`,
    },

    {
      title: `PARTICIPATION PERIOD`,
      details: `The Contest will run from February 12, 2024, to February 16, 2024, inclusive of these dates.`,
    },
    {
      title: `PARTICIPATION LIMITS`,
      details: `a. Eligible participants can engage in the Contest once a day during the specified participation period.
        `,
    },
    {
      title: ``,
      details: `b. Each participant is entitled to a maximum of two attempts a day.`,
    },
    {
      title: `PRIZE REDEMPTION`,
      details: `a. Prizes won can be redeemed through the MTN Pulse section on myMTN App.`,
    },
    {
      title: ``,
      details: ` b. For physical items, participants must claim their prizes at the nearest MTN office
      with the provided reference code.`,
    },
    {
      title: ``,
      details: ` c. Redemption options for all prizes or rewards will be clearly outlined on the Pulse
      Section of myMTN App.`,
    },
    {
      title: `PRIZE AVAILABILITY`,
      details: `a. Prizes are subject to availability, and MTN reserves the right to substitute any prize
      with another of equivalent value without prior notice.`,
    },
    {
      title: ``,
      details: ` b. Out-of-stock items will be indicated on the wheel, and landing on such items results
      in a lost attempt.`,
    },
    {
      title: `NOTIFICATION`,
      details: `a. Participants will receive an on-screen notification immediately after spinning the wheel, revealing their prize.
      `,
    },
    {
      title: ``,
      details: `b. An in-app notification will follow, providing details of the awarded prize.`,
    },
    {
      title: `REPLAY AND EXIT`,
      details: `a. Participants do not have the option to replay the game once a prize has been claimed or the maximum attempts have been exhausted.
      `,
    },
    {
      title: ``,
      details: `b. Exiting the Contest interface after claiming a prize or running out of attempts is final.`,
    },
    {
      title: `USER CONDUCT`,
      details: `a. Participants must adhere to the terms and conditions and any additional rules
      communicated by MTN.`,
    },
    {
      title: ``,
      details: `b. Any attempt to manipulate or exploit the Contest may result in disqualification.`,
    },
    {
      title: `DATA PRIVACY`,
      details: `By participating, participants consent to the collection and use of their personal
      information by MTN for the purpose of the Contest.`,
    },
    {
      title: `GENERAL`,
      details: `a. MTN reserves the right to modify, suspend, or terminate the Contest at any time
      without prior notice.`,
    },
    {
      title: ``,
      details: `b. These terms and conditions may be subject to change, and participants are encouraged to review them regularly.
      `,
    },
    {
      title: ``,
      details: `c. By participating in the Contest, participants acknowledge that they have read, understood, and agreed to abide by these terms and conditions.
     `,
    },
    {
      title: ``,
      details: `d. The Contest shall be governed by the Laws of Ghana.`,
    },
  ],
};

export default pulseSpinTheWheeltnc;
